import { render, staticRenderFns } from "./SplitButton.vue?vue&type=template&id=70fa0a18&scoped=true&"
import script from "./SplitButton.vue?vue&type=script&lang=js&"
export * from "./SplitButton.vue?vue&type=script&lang=js&"
import style0 from "./SplitButton.vue?vue&type=style&index=0&id=70fa0a18&scoped=true&lang=scss&"
import style1 from "./SplitButton.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fa0a18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
